// extracted by mini-css-extract-plugin
module.exports = {"internalLink":"style_internalLink__pQnJZ","listInternalLink":"style_listInternalLink__1fkh5"};